<template>
  <v-app>
    <c-summary-navbar
      :userName="eipUserName"
      :protalName="'Search Partner'"
      @userLogout="logout()"
    />
    <w-loading-spinner :loadSpinner="pageLoader" />
    <div class="row" style="width: 90%;margin: 0px auto;background: #f3f3f3;margin-bottom: 5px;
    box-shadow: #c5c5c5 0px 3px 10px">
      <div style="width: 100%;">
      <div style="width: 96%;float: left;margin: 15px 20px;margin-top: 0px;color: #152735;font-size: 16px;text-align: left;">    
          <div style="font-weight: bold;text-align: left;font-size: 16px;
          padding-bottom: 10px;padding-top: 10px;">Partner Search</div>   
          <div class="row">
            <div class="col-4 col-md-12 col-lg-4" style="padding: 0px 25px 0px 0px;"> 
              
      <span style="font-size: 15px;padding-left: 15px;" class="exo">Search by Partner:</span>
      <input @input="searchDebounce()" v-model="searchTerm" class="form-control" 
      placeholder="Minimum 5 characters" @focus="resetOtherThan('general')"
      style="padding: 5px 10px;height: 37px;margin-left: 15px;"/>
    <!--w-search-partner></w-search-partner-->
            </div>
            
    <div class="col-4 col-md-12 col-lg-4">
      <span style="font-size: 15px;" class="exo">Search by Category:</span>
    <b-form-group class="source-sans-pro field-headings"> 
         <input type="text" class="form-control" v-model="categorysearchterm"
        placeholder="Search Category Minimum 3 character.." id="categorysearchelement"
        style="padding-right:35px;height: 37px;" autocomplete="off" @input="onCategorySearch()"
        @focus="resetOtherThan('category')"
        :title="'Search Category'"/>
        <span @click="resetCategory()" class="reset-close">x</span>
      <div class="result-dd"
      v-if="categorysearchterm !== undefined && isCategorySelected == false
      && categorysearchterm !== null
      && categorysearchterm.length > 2">
        <div v-for="(c,i) in showFilteredCats"
        style="border-bottom: 2px solid #ccc;padding-top: 3px;cursor:pointer;border: 1px solid #ccc;
        padding: 0px 5px;padding-bottom: 10px;    text-align: left;" v-bind:key="i"
        @click="getCatSelected(c.categoryCode)">
          {{c.longDesc}}-{{c.erpMapCode}}
        </div>
      </div>
    </b-form-group>
    </div>
<!-- location-->
    <div class="col-4 col-md-12 col-lg-4">
      <span style="font-size: 15px;" class="exo">Search by Location:</span>
    <b-form-group class="source-sans-pro field-headings"> 
         <input type="text" class="form-control" v-model="locationsearchterm"
        placeholder="Search Location Minimum 3 character.." id="locationsearchelement"
        style="padding-right:35px;height: 37px;" autocomplete="off" @input="onLocationSearch()"
         @focus="resetOtherThan('location')"
        :title="'Search Location'"/>
        <span @click="resetLocation()" class="reset-close">x</span>
      <div class="result-dd"
      v-if="locationsearchterm !== undefined && isLocationSelected == false
      && locationsearchterm !== null
      && locationsearchterm.length > 2">
        <div v-for="(c,i) in showFilteredLocs"
        style="border-bottom: 2px solid #ccc;padding-top: 3px;cursor:pointer;border: 1px solid #ccc;
        padding: 0px 5px;padding-bottom: 10px;    text-align: left;" v-bind:key="i"
        @click="getLocSelected(c.cityCode)">
          {{c.cityName}}
        </div>
      </div>
    </b-form-group>
    </div>
    </div>
    <v-expansion-panel style="max-width: 100%;padding: 0px !important;
    margin: 0px !important;width: 100% !important;border: 0px;
    margin: -30px -20px 0px !important;">
      <v-expansion-panel-content>
         <template v-slot:header>
           Advance Filters:
            </template>
          <v-card style="margin-left: 30px;background: transparent !important;">
           <div style="font-size: 14px;color: #3e3e3e;padding: 0px 10px;margin-top: -15px;" class="exo">
   <span style="font-size: 18px;color: #ff9800;"> &#9888;</span> Use advance filters only if required as combination of filters may hide intended results. Select 'All' to remove unnecessary filtering</div>

    <div class="row" style="margin-top: 5px;">
      <div class="col-12">
        <!--div style="font-size: 14px;color: #333;" class="exo">Additional Filters:</div-->
        <div style="display: inline-block;padding: 0px 10px;">
      <b-form-group
      label="Vendor Onboarding Status:"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="btn-radios-2"
        v-model="selectedStatusFilter"
        @input="onfilterChange(selectedStatusFilter,selectedClassificationFilter)"
        :options="statusradiooptions"
        :aria-describedby="ariaDescribedby"
        button-variant="outline-primary"
        size="md"
        name="radio-btn-outline"
        buttons
      ></b-form-radio-group>
    </b-form-group></div>
    <div style="display: inline-block;padding: 0px 10px;">
      <b-form-group
      label="Vendor Classification:"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="btn-radios-2"
        v-model="selectedClassificationFilter"
        @input="onfilterChange(selectedStatusFilter,selectedClassificationFilter)"
        :options="classificcationradiooptions"
        :aria-describedby="ariaDescribedby"
        button-variant="outline-primary"
        size="md"
        name="radio-btn-outline"
        buttons
      ></b-form-radio-group>
    </b-form-group>
      </div>
  
</div>
      </div>

            </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
          </div>
          
    <!--button class="btn btn-primary" @click="isopen = !isopen">Advanced Search</button>
    <div style="margin-top: 10px;background: #fff;">
<div class="item" :class="{'active':isopen}">
    
</div>
    </div-->
</div>
          
       
      </div>
    </div>
    <div class="forensic-container" style="padding:5px 20px 50px 20px;width: 90%;
    margin: 0px auto 5px;background: #f3f3f3;">
    <span style="display: block;font-weight: bold;" v-show="vendorList.length==0" >
      No records to show! give valid search term to see the results.</span>
    <span style="text-align: left;display: block;font-weight: bold;" v-show="vendorList.length>0" >Search Results:</span>
    <vue-good-table :style="[vendorList.length==0 ? {visibility: 'hidden'} : {visibility: 'visible'}]" @on-sort-change="onSortChange" :ref="'mytable'" theme="black-rhino"
    @on-page-change="onPageChange"
    @on-per-page-change="onPageChange"
    @on-search="onSearch"
      :columns="columns"
      :rows="vendorList"
      max-height="500px"
  :fixed-header="true" 
  :search-options="{
    enabled: false
  }"
  :styleClass="'vgt-table striped condensed'"
  :totalRows="totalRecords"
  :pagination-options="{
    enabled: true,
    mode: 'records',
    perPage: 10,
    position: 'top',
    perPageDropdown: [10, 50, 100],
    dropdownAllowAll: false, 
    setCurrentPage: 1,
    nextLabel: 'next',
    prevLabel: 'prev',
    rowsPerPageLabel: 'Rows per page',
    ofLabel: 'of',
    pageLabel: 'page', // for 'pages' mode
    allLabel: 'All',
  }"/>
    </div>
  </v-app>
</template>

<script>
import EmpanelmentNavbar from "@/components/EmpanelmentNavbar.vue";
import moment from "moment";
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();
import multiSelect from "vue-multi-select";
import Modal from "../widgets/newModalWidget";
import textArea from "../widgets/TextArea";
import SearchPartner from "../widgets/SearchPartner";
import SummaryNavbar from "../components/summary/summaryNavbar";
import LoadingSpinner from "../widgets/LoadingSpinner";
import DropDown from "../widgets/DropDown";
import { VueGoodTable } from 'vue-good-table';

import 'vue-good-table/dist/vue-good-table.css'

import { AESService } from "../services/AES.js";
let aesService = new AESService();
export default {
  props: ["answer", "userId"],
  components: {
    "c-empanelment-navbar": EmpanelmentNavbar,
    multiSelect,
    "w-modal": Modal,
    "w-textArea": textArea,
    "w-text-area": textArea,
    "w-loading-spinner": LoadingSpinner,
    "c-summary-navbar": SummaryNavbar,
    "w-dropDown": DropDown,
    "w-search-partner":SearchPartner,
    VueGoodTable 
  },
  watch: {},
  computed: {},
  created() {
    var self = this
    $(document).on('click', '[id^="forensic"]', function(e){      
        e.preventDefault();
        e.stopPropagation();
      self.goToForensicPage(e.target.id.split('~~~')[1],e.target.id.split('~~~')[2]);
      //}
    })
    $(document).on('click', '[id^="profile"]', function(e){      
        e.preventDefault();
        e.stopPropagation();
      self.goToVendorMasterPage(e.target.id.split('~~~')[1],e.target.id.split('~~~')[2]);
      //}
    })
    this.answerNumber = this.$route.params.answer;
    this.userId = this.$route.params.userId;
    this.eipUserName = this.$route.params.userName;
    this.decryptfunction();
  },
  mounted() {
    var self = this; 
    EventBus.$on('partnerSelected',function(e){
      self.currentSearchBy = 'partnerNumber'
      self.currentSearchTerm =  sessionStorage.getItem("partnerSelectedValue").split('-')[0]
      self.hideRankColumn()
      self.getForensicList(self.currentSearchBy,self.currentSearchTerm, sessionStorage.getItem("partnerSelectedValue").split('-')[3])
    }) 
    
      SummaryService.getCategoriesList(1)
        .then(res => {
          if(res.failureMessage != ''){
             window.alert(res.failureMessage)
          } else {
            self.catList = res.response
          }
        })
        .catch(err => {
          window.alert('Something went wrong')
        });

        
      SummaryService.getLocationsList(1)
        .then(res => {
          if(res.failureMessage != ''){
             window.alert(res.failureMessage)
          } else {
            self.locList = res.response
          }
        })
        .catch(err => {
          window.alert('Something went wrong')
        });
    
   //window.setTimeout(self.applyColors(),5000)
    //self.getForensicList() 
  },
  data() {
    return {  
      selectedStatusFilter: false,
        statusradiooptions: [
          { text: 'ALL', value: false },
          { text: 'Only - Primary Profile Approved/ Submitted', value: true }],
      selectedClassificationFilter: 0,
        classificcationradiooptions: [
          { text: 'ALL', value: 0 },
          { text: 'Pan L&T', value: 1 },
          { text: 'Contingent', value: 2 }
        ],
      searchTimeout: '',
      searchTerm:'',
      locationsearchterm: '',
      isLocationSelected: false,
      isopen: false,    
      isCategorySelected: false,
      categorysearchterm:'',
      currentSearchBy:'',
      currentSearchTerm:'',
      selectedCategory:'',
      catList:[],
      showFilteredCats:[],
      showFilteredLocs: [],
      locList:[],
      currentSortOrder: 'asc',
      currentSortType: 'longDesc',
      totalRecords: 0,
      vendorList: [],
      navigateOnSuccessModalClose: true,
      enableSubmit: true,
      toSendBackList: [],
      sendBackTo: "",
      partnerList: [],
      isloading: false,
      userId: "",
      actualEIPUserId: "",
      eipUserName: "",
      overAllRemarks: "",
      successModal: false,
      failureModal: false,
      triggerModal: false,
      pageLoader: false,
      position: "bottom",
      columns: [
        {
          label: 'Vendor Name',
          field: 'longDesc',
          type: 'String'
        },
        {
          label: 'Partner.No',
          field: 'partnerNumber',
          type: 'String'
        },
        {
          label: 'Rank',
          field: 'rank',
          type: 'Number'
        },
        {
          label: 'Overall Score',
          field: 'overallScoreHTML',
          html: true
        },
        {
          label: 'Hygiene',
          field: 'hygieneScoreHTML',
          html: true
        },
        {
          label: 'Confidence',
          field: 'confidenceScoreHTML',
          html: true
        },
        {
          label: 'Reliability',
          field: 'reliabilityScoreHTML',
          html: true
        },
        {
          label: 'Sentiment',
          field: 'sentimentScoreHTML',
          html: true
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
          html: true
        },
      ]
    };
  },
  methods: {   
    getSearchTerm(event) {
      var self = this
      event = event.trim();
      if (event.length > 4) {
        this.searchLoading = true;
        let searchData = {
          input: event
        };
        SummaryService.
        getPartnerSuggestion(searchData)
          .then(res => {
            self.vendorList = (res)

          self.totalRecords = (res.length)
          
            self.vendorList.map(
              x =>
                (x.actions = `<span style="
    white-space: nowrap;">
<button style=" padding:0px 10px !important;background-color: #fff;
    color: #004d8c;" class="btn btn-primary custom-btn" 
  id="forensic~~~${x.partnerId}~~~${x.partnerNumber}">View Forensics</button>
           <button style=" padding:0px 10px !important;background-color: #fff;
    color: #004d8c;" class="btn btn-primary custom-btn" 
  id="profile~~~${x.partnerId}~~~${x.partnerNumber}">View Profile</button></span>`));

            self.vendorList.map(x =>(x.hygieneScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.hygieneScore || x.hygieneScore == 0?x.hygieneScore:'100') + '%'};
              background-color:${self.getColor(x.hygieneScore)};
              color:${self.getTextColor(x.hygieneScore)}">
              <span class="indicator">${x.hygieneScore || x.hygieneScore == 0 ? x.hygieneScore : "no data"}</span>
              </div></div>`));

            
            self.vendorList.map(x =>(x.confidenceScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.confidenceScore || x.confidenceScore == 0?x.confidenceScore:'100') + '%'};
              background-color:${self.getColor(x.confidenceScore)}";
              color:${self.getTextColor(x.confidenceScore)}">
              <span class="indicator">${x.confidenceScore || x.confidenceScore == 0? x.confidenceScore : "no data"}</span>
              </div></div>`));
            
            self.vendorList.map(x =>(x.sentimentScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.sentimentScore || x.sentimentScore == 0?x.sentimentScore:'100') + '%'};
              background-color:${self.getColor(x.sentimentScore)}";
              color:${self.getTextColor(x.sentimentScore)}">
              <span class="indicator">${x.sentimentScore || x.sentimentScore == 0? x.sentimentScore : "no data"}</span>
              </div></div>`));
            
            self.vendorList.map(x =>(x.reliabilityScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.reliabilityScore || x.reliabilityScore == 0?x.reliabilityScore:'100') + '%'};
              background-color:${self.getColor(x.reliabilityScore)}";
              color:${self.getTextColor(x.reliabilityScore)}">
              <span class="indicator">${x.reliabilityScore || x.reliabilityScore == 0? x.reliabilityScore : "no data"}</span>
              </div></div>`));

              
            self.vendorList.map(x =>(x.overallScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.overallScore || x.overallScore == 0?x.overallScore:'100') + '%'};
              background-color:${self.getColor(x.overallScore)}";
              color:${self.getTextColor(x.overallScore)}">
              <span class="indicator">${x.overallScore || x.overallScore == 0? x.overallScore : "no data"}</span>
              </div></div>`));
            
          })
          .catch(err => {
            this.searchLoading = false;
            console.log(err);
          });
      } else {
        this.searchLoading = false;
        this.searchSource = [];
      }
    }, 
    
    searchDebounce(){
      var self=this
      this.selectedStatusFilter = false
      this.selectedClassificationFilter = 0
     window.clearTimeout(self.searchTimeout);
     self.searchTimeout = window.setTimeout(function(){self.getPartnerList()}, 700);
    },
    getPartnerList(){
      if(this.searchTerm.trim().length>4){
        this.currentSearchBy = 'general'
        //this.getSearchTerm(this.searchTerm)
        this.currentSearchTerm = this.searchTerm.trim()
        this.getForensicList(this.currentSearchBy, this.currentSearchTerm)
      }
    },
    hideRankColumn(){
     this.$set(this.columns[2], 'hidden', true)
    },   
    showRankColumn(){
     this.$set(this.columns[2], 'hidden', false)
    },
    resetOtherThan(e){
      //this.hideRankColumn()
      
       this.$refs.mytable.reset()
      if(e=='category'){
        this.locationsearchterm = ''
        this.searchTerm = ''
        this.currentSearchTerm = ''
        EventBus.$emit('resetSearch')
      }
      if(e=='location'){
        this.categorysearchterm = ''
        this.searchTerm = ''
        this.currentSearchTerm = ''
        EventBus.$emit('resetSearch')
      }
      if(e=='general'){
        this.categorysearchterm = ''
        this.locationsearchterm = ''
        //this.currentSearchTerm = ''
        EventBus.$emit('resetSearch')
      }
    },
    resetCategory(){
        this.hideRankColumn()
      this.categorysearchterm = '';
    },
    resetLocation(){
        this.hideRankColumn()
      this.locationsearchterm = '';
    },
    onLocationSearch(){
      this.selectedStatusFilter = false
      this.selectedClassificationFilter = 0
      this.isLocationSelected = false
       // this.hideRankColumn()
      if(this.locationsearchterm.trim().length>2){
        this.showFilteredLocs = this.locList.filter(x=>
        (x.cityCode && x.cityName.toLowerCase().indexOf(this.locationsearchterm.toLowerCase()) > -1))
        console.log(this.showFilteredLocs)
      }

    },
    onCategorySearch() {
      this.selectedStatusFilter = false
      this.selectedClassificationFilter = 0
      this.isCategorySelected = false
      if(this.categorysearchterm.trim().length>2){
        this.showFilteredCats = this.catList.filter(x=>
        (x.erpMapCode && x.erpMapCode.toLowerCase().indexOf(this.categorysearchterm.toLowerCase()) > -1) ||
        (x.longDesc && x.longDesc.toLowerCase().indexOf(this.categorysearchterm.toLowerCase()) > -1))
        console.log(this.showFilteredCats)
      }
    },
    resetAllFilters() {
      this.selectedCategory = ''
    },
    getCatSelected(e){
      var self = this
      this.showRankColumn()
      self.isCategorySelected = true
      self.currentSearchBy = 'category'
      self.selectedCategory = e
      self.currentSearchTerm = e
      self.getForensicList(self.currentSearchBy, self.currentSearchTerm)
    },

    getLocSelected (e){
      var self = this
      this.showRankColumn()
      self.isLocationSelected = true
      self.currentSearchBy = 'city'
      self.selectedLocation = e
      self.currentSearchTerm = e
      self.getForensicList(self.currentSearchBy, self.currentSearchTerm)
    },
    getForensicList(searchby,searchterm, pan){
      var self = this
      self.isopen = false;
      pan = pan ? pan : '';
      var payload={
                  "isProfileCompleted":self.selectedStatusFilter,
                  "classificationCode":self.selectedClassificationFilter
                  }
      SummaryService.getForensicList(self.$refs.mytable.currentPage-1, self.$refs.mytable.currentPerPage,
      self.currentSortType, self.currentSortOrder, searchby, searchterm, pan, payload) 
        .then(res => { 
          if(res.failureMessage!=""){
            self.vendorList = []
            self.totalRecords = 0
            //window.alert(res.failureMessage + ", Try again later!")
          } else {
          self.vendorList = (res.response.content)
          self.totalRecords = (res.response.totalElements)
          /*self.vendorList.forEach(function(x,i) {
            self.vendorList[i].confidenceScore = self.vendorList[i].confidenceScore ? 
          Math.round(self.vendorList[i].confidenceScore) : null
            self.vendorList[i].reliabilityScore = self.vendorList[i].reliabilityScore ? 
          Math.round(self.vendorList[i].reliabilityScore) : null
            self.vendorList[i].sentimentScore = self.vendorList[i].sentimentScore ? 
          Math.round(self.vendorList[i].sentimentScore) : null
            self.vendorList[i].hygieneScore =  self.vendorList[i].hygieneScore ? 
          Math.round(self.vendorList[i].hygieneScore) : null
            self.vendorList[i].overallScore =  self.vendorList[i].overallScore ? 
          Math.round(self.vendorList[i].overallScore) : null
          })*/
            self.vendorList.map(
              x =>
                (x.actions = `<span style="
    white-space: nowrap;">
<button style=" padding:0px 10px !important;background-color: #fff;
    color: #004d8c;" class="btn btn-primary custom-btn" 
  id="forensic~~~${x.partnerId}~~~${x.partnerNumber}">View Forensics</button>
           <button style=" padding:0px 10px !important;background-color: #fff;
    color: #004d8c;" class="btn btn-primary custom-btn" 
  id="profile~~~${x.partnerId}~~~${x.partnerNumber}">View Profile</button></span>`));

            self.vendorList.map(x =>(x.hygieneScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.hygieneScore || x.hygieneScore == 0?x.hygieneScore:'100') + '%'};
              background-color:${self.getColor(x.hygieneScore)};
              color:${self.getTextColor(x.hygieneScore)}">
              <span class="indicator">${x.hygieneScore || x.hygieneScore == 0 ? x.hygieneScore : "no data"}</span>
              </div></div>`));

            
            self.vendorList.map(x =>(x.confidenceScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.confidenceScore || x.confidenceScore == 0?x.confidenceScore:'100') + '%'};
              background-color:${self.getColor(x.confidenceScore)}";
              color:${self.getTextColor(x.confidenceScore)}">
              <span class="indicator">${x.confidenceScore || x.confidenceScore == 0? x.confidenceScore : "no data"}</span>
              </div></div>`));
            
            self.vendorList.map(x =>(x.sentimentScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.sentimentScore || x.sentimentScore == 0?x.sentimentScore:'100') + '%'};
              background-color:${self.getColor(x.sentimentScore)}";
              color:${self.getTextColor(x.sentimentScore)}">
              <span class="indicator">${x.sentimentScore || x.sentimentScore == 0? x.sentimentScore : "no data"}</span>
              </div></div>`));
            
            self.vendorList.map(x =>(x.reliabilityScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.reliabilityScore || x.reliabilityScore == 0?x.reliabilityScore:'100') + '%'};
              background-color:${self.getColor(x.reliabilityScore)}";
              color:${self.getTextColor(x.reliabilityScore)}">
              <span class="indicator">${x.reliabilityScore || x.reliabilityScore == 0? x.reliabilityScore : "no data"}</span>
              </div></div>`));

              
            self.vendorList.map(x =>(x.overallScoreHTML = `<div class="progress-wrap">
              <div class="inset-text" style="text-align: right;width:${(x.overallScore || x.overallScore == 0?x.overallScore:'100') + '%'};
              background-color:${self.getColor(x.overallScore)}";
              color:${self.getTextColor(x.overallScore)}">
              <span class="indicator">${x.overallScore || x.overallScore == 0? x.overallScore : "no data"}</span>
              </div></div>`));
            }
        })
        .catch(err => {
          window.alert('something went wrong!')
        });
    },
    applyColors(){
      $('td.vgt-left-align').get().forEach(function(entry, index, array) {
        var val = array[index].innerText.trim().replace(/%/g,''); 
        if(!isNaN(val)){
          $(entry).css('background',getColor(val))
        }
      });
    },
    getColor(s) {
      if (s) {
      if (s > 70) {
        return "#1ee426";
      } else if (s < 30) {
        return "#ff4b4b";
      } else {
        return "orange";
      }
      } else {
        return "white"
      }
    },
    getTextColor(s) {
      return s ? '#fff' : "#333"
    },
  onPageChange(currentPage, currentPerPage, total) {
    var self = this
    this.getForensicList(self.currentSearchBy, self.currentSearchTerm)
  },
  onfilterChange(selectedStatusFilter,selectedClassificationFilter) {
    var self = this
    self.selectedStatusFilter = selectedStatusFilter
    self.selectedClassificationFilter = selectedClassificationFilter
    this.getForensicList(self.currentSearchBy, self.currentSearchTerm)
  },
  onSortChange(sortType, columnIndex) {
    this.currentSortType = (sortType[0].field).replace('HTML','')
    this.currentSortOrder = (sortType[0].type).replace('HTML','')
    var self = this
    this.getForensicList(self.currentSearchBy, self.currentSearchTerm)
  },
    goToForensicPage(p,pn){    
       const routeData = this.$router.resolve({name: 'partnerforensics', query:{pid: p,pno:pn }})
      window.open(routeData.href, '_blank')  
     // this.$router.push("/partnerforensics");
    }, 
    goToVendorMasterPage(p,pn){    
       const routeData = this.$router.resolve({name: 'VendorDetails', query:{pid: p,pno:pn }})
      window.open(routeData.href, '_blank')  
     // this.$router.push("/partnerforensics");
    }, 
    decryptfunction() {
      var self = this;
      var CryptoJS = require("crypto-js");
      var token = sessionStorage.getItem("summaryToken");
      var bytes =
        token &&
        CryptoJS.AES.decrypt(token.toString(), atob(process.env.VUE_APP_S_S));
      var decryptedData =
        bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptedData) {
        this.answerNumber = decryptedData.decodedRequestNumber;
        this.userId = decryptedData.eipUsersUserid;
        this.userCode = decryptedData.evaluatorsFRCode;
        this.eipUserName = decryptedData.eipUserName;
        this.auditNo = decryptedData.auditNumber;
      }
    }, 
    logout() {
      let data = {};
      var logouttime = new Date(); 
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(this.auditNo);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      SummaryService.userLogout(data)
        .then(res => {
          sessionStorage.clear();
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL); 
        })
        .catch(err => {
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    }
  }
};
</script>
<style scoped>
.item {
  opacity: 0;
  height: 0;
  transition:  padding 0.4s, opacity 0.1s 0.1s, height 0.4s;
}

.active{
  opacity: 1;padding:10px;
  height: 88px;
  transition: padding 0.4s, opacity 0.1s 0.1s, height 0.4s;
}
.custom-btn{
  padding:0px 10px !important; 
  background-color:#09599a !important;
}
.ele {
  text-align: left;
  font-size: 14px;
}

.vgt-table th, .vgt-table td{max-width: 400px !important;overflow: auto;word-break: break-all;}
.vgt-fixed-header{display: none !important;}

.vgt-table th{  
  padding: 5px 10px !important;
    font-size: 14px !important;
    background-color: #1a72ab !important;
    background: #1a72ab !important;
    color:#fff !important;
}
table.vgt-table td{ 
  padding: 5px 10px !important;
    font-size: 14px !important;
}
table.vgt-table tr:nth-child(even) {background-color: #f2f2f2;}
.footer__row-count__select{
  width: 30px !important;
  padding: 5px !important;
}

.vgt-table th, .vgt-table td{
  font-size: 14px !important;max-width: 240px;
}

table.vgt-table{
  font-size: 14px !important;
}

.reset-close{
  font-size: 18px;position: relative;top: -30px;left: 120px;
  border-left: 1px solid #ccc;padding-left: 7px;padding-right: 7px;
  left: 92%;cursor:pointer;
}
.result-dd{
  max-height:200px;overflow: auto;overflow-x:hidden;margin-top: -20px;
  background: #fff;z-index: 9999999999;position: absolute;font-size: 14px;width: 90%;
}
.exo{
  font-family: "Exo", sans-serif !important;
}
.form-group{
  margin-bottom: 0px !important;
}
.v-expansion-panel__container{
  background: transparent !important;
}
</style>